export default function transformKey(key = "") {
  const chain = "-····-····-····-·";
  return key.substr(0, 8) + chain + key.substring(key.length - 4, key.length);
}
